import { render, staticRenderFns } from "./ProcessingPayment.vue?vue&type=template&id=536bcab0&"
import script from "./ProcessingPayment.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProcessingPayment.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports